export const en = {
    ristournePastille: "Dividend",
    ristourneLien: "See dividend details",
};
